// === FEATURE FLAG : ÎLE PIXEL ART ===
// Bascule entre l'ancien CampScene (menu de cartes) et le nouvel IslandCampScene
// (vue top-down pixel art). Stocké en localStorage pour persister entre lancements.
//
// Depuis v0.40.6-beta (Sprint A4 final) : l'île pixel art est activée PAR DÉFAUT.
// Le flag ne sert plus qu'à désactiver explicitement le nouveau camp pour ceux
// qui veulent retomber sur l'ancien (escape hatch, debug). DevScene expose le
// toggle, et le panneau d'affichage de l'île offre un raccourci « Ancien camp »
// qui ouvre `CampScene` ponctuellement sans changer le flag.
//
// Sémantique localStorage :
//   - clef absente   → enabled (défaut)
//   - clef = '1'     → enabled (rétro-compat avec versions précédentes)
//   - clef = '0'     → disabled (l'utilisateur a choisi l'ancien camp)

const STORAGE_KEY = 'deadtide_island_camp';

function safeGet(key: string): string | null {
  try { return localStorage.getItem(key); } catch { return null; }
}

function safeSet(key: string, value: string): void {
  try { localStorage.setItem(key, value); } catch { /* localStorage indisponible */ }
}

function safeRemove(key: string): void {
  try { localStorage.removeItem(key); } catch { /* localStorage indisponible */ }
}

export const IslandCampFlag = {
  /**
   * Renvoie true si l'île pixel art doit remplacer l'ancien camp.
   * Défaut : true (depuis v0.40.6-beta). Seule la valeur explicite '0'
   * désactive l'île.
   */
  isEnabled(): boolean {
    return safeGet(STORAGE_KEY) !== '0';
  },

  /** Force l'activation (efface la clef pour repasser au défaut). */
  enable(): void {
    safeRemove(STORAGE_KEY);
  },

  /** Désactive explicitement l'île (l'utilisateur veut l'ancien camp). */
  disable(): void {
    safeSet(STORAGE_KEY, '0');
  },

  /** Bascule l'état du flag et renvoie la nouvelle valeur. */
  toggle(): boolean {
    if (this.isEnabled()) {
      this.disable();
      return false;
    }
    this.enable();
    return true;
  },

  /**
   * Renvoie la clé de scène de camp à utiliser selon l'état du flag.
   * Centralise le test "IslandCampScene vs CampScene" pour tous les retours
   * "← Camp" depuis les sous-scènes (Storage, Atelier, Dorm, Vigie, Tavern...).
   */
  campSceneKey(): 'IslandCampScene' | 'CampScene' {
    return this.isEnabled() ? 'IslandCampScene' : 'CampScene';
  },
};
